import { useCallback, useState } from 'react';
import { NodeType, OUNode, Site } from '../types';

let siteIdCounter = 200;

export function useSites(initialSites: Site[]) {
  const [sites, setSites] = useState<Site[]>(initialSites);

  const assignSite = useCallback((siteId: string, nodeId: string | null) => {
    setSites(prev => prev.map(s =>
      s.id === siteId
        ? { ...s, assignedNodeId: nodeId, updatedAt: new Date().toISOString().split('T')[0] }
        : s
    ));
  }, []);

  const unassignSite = useCallback((siteId: string) => {
    setSites(prev => prev.map(s =>
      s.id === siteId
        ? { ...s, assignedNodeId: null, updatedAt: new Date().toISOString().split('T')[0] }
        : s
    ));
  }, []);

  const unassignAllFromNode = useCallback((nodeId: string) => {
    setSites(prev => prev.map(s =>
      s.assignedNodeId === nodeId
        ? { ...s, assignedNodeId: null, updatedAt: new Date().toISOString().split('T')[0] }
        : s
    ));
  }, []);

  const createAndAssignSite = useCallback((
    siteId: string,
    nodeName: string,
    nodeType: NodeType,
    nodeParentId: string | null,
    addNode: (name: string, type: NodeType, parentId: string | null) => string
  ) => {
    const newNodeId = addNode(nodeName, nodeType, nodeParentId);
    setSites(prev => prev.map(s =>
      s.id === siteId
        ? { ...s, assignedNodeId: newNodeId, updatedAt: new Date().toISOString().split('T')[0] }
        : s
    ));
    return newNodeId;
  }, []);

  const bulkAssignSites = useCallback((siteIds: string[], nodeId: string) => {
    const idSet = new Set(siteIds);
    setSites(prev => prev.map(s =>
      idSet.has(s.id)
        ? { ...s, assignedNodeId: nodeId, updatedAt: new Date().toISOString().split('T')[0] }
        : s
    ));
  }, []);

  return { sites, setSites, assignSite, unassignSite, unassignAllFromNode, createAndAssignSite, bulkAssignSites };
}
